import MenuButton from "../buttons/MenuButton";
import TieredMenuButton from "../buttons/TieredMenuButton";

export const MenuCommandCell = (props) => {
  const { style, className, colSpan, myMenuModel, isTieredMenu = false} = props;

  return (
    <td style={style} className={className} colSpan={colSpan} role="gridcell">
      <div className="row">
        <div className="col-1">
          {isTieredMenu ? (
            <TieredMenuButton
              menuModel={myMenuModel}
              modelProps={props}
              icon="ellipsis"
              btnColor="light"
            />
          ) : (
            <MenuButton
              title="Options"
              props={props}
              collectionMenuModel={myMenuModel}
            />
          )}
        </div>
      </div>
    </td>
  );
};

